import { ApplicationNotification, ApplicationNotificationSpecificationBase } from './common';
import type { FC } from 'react';

export type Type = 'information';

interface Specification extends ApplicationNotificationSpecificationBase<BannerNotification> {
	type: Type;
	sid?: string;
	ui: FC<{ message: BannerNotification }>;
}

export class BannerNotification extends ApplicationNotification {
	public readonly ui: FC;
	public readonly event = 'banner';
	public readonly type: Type;

	constructor(spec: Specification) {
		super(spec.sid);

		const BannerMessageUi: FC = () => {
			return <spec.ui message={this} />;
		};
		this.ui = BannerMessageUi;
		this.type = spec.type;
	}
}
